export const TemplatesPage = () => {
  return <div>TemplatesPage</div>;
};
